<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path d="m19 4.3-11 11-.7.7.7.7 11 11 1.5-1.4L10.2 16 20.5 5.7Z" />
  </svg>
</template>
